import { Fragment, h } from "preact";
import { translate, t } from "../../I18n";
function CreatorFooter(props) {
    const { price, isSubmitVisible, isCancelVisible, isSubmitDisabled, onSubmit, } = props;
    return (h("div", { class: "modal-footer modal-footer--sticky" },
        h("div", { class: "modal-footer__actions" },
            isCancelVisible && (h("button", { "data-bs-dismiss": "modal", class: "btn btn-default", type: "button", "data-field-id": "Creator.backToMenu" }, translate(t.theme_defaults.creator.back_to_menu))),
            isSubmitVisible && (h("button", { class: `btn btn-primary ${isSubmitDisabled && "disabled"}`, type: "button", "data-field-id": "Creator.addToCart", onClick: onSubmit },
                translate(t.theme_defaults.creator.add_to_cart),
                price ? (h(Fragment, null,
                    " (",
                    h("span", { "data-field-id": "Creator.price", "data-field-type": "info" }, price),
                    ")")) : (
                // Empty field so that structure is the same
                h("span", { "data-field-id": "Creator.price", "data-field-type": "info" })))))));
}
export default CreatorFooter;
